import api from "../http";

export default class ApiGamesUrl {
  static async getApiGamesUrl(url) {
    return api.get(url)
  }
}